import { render, staticRenderFns } from "./StateFascicolo.vue?vue&type=template&id=012ad4b6&"
import script from "./StateFascicolo.vue?vue&type=script&lang=js&"
export * from "./StateFascicolo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports